// @flow

export const TERMS_LINK = 'https://www.idwell.com/terms-and-conditions'
export const GDPR_LINK = 'https://www.idwell.com/gdpr'
export const PASS_INFO_LINK =
  'https://idwell.crunch.help/de/allgemein/welche-kriterien-gibt-es-fur-die-passwortvergabe'
